// extracted by mini-css-extract-plugin
export default {"main":"Iiko_main__0o9hS","container":"Iiko_container__hvjHA","container__header":"Iiko_container__header__DQjWh","container__header__title":"Iiko_container__header__title__VjLWX"};